import request from '../../utils/request'
const urlParams = process.env.VUE_APP_UPLOAD_REAL_PATH
export default {
  // 获取设备列表
  deviceUpholdList(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold/list',
      type: 'get',
      params: params
    })
  }, 
  // 获取设备列表新增
  deviceUpholdUpdata(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },  
  // 获取设备列表删除
  deviceUpholdDelete(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold/delete',
      type: 'post',
      params: params
    })
  }, 
  // 生成二维码
  generateQrCode(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold/generateQrCode',
      type: 'post',
      params: params
    })
  },     
  // 类型修改添加
  deviceUpholdCategoryUpdata(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold-category/addUp',
      type: 'post',
      params: params,
      qs:false
    })
  },   
  // 类型列表
  deviceUpholdCategoryList(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold-category/list',
      type: 'get',
      params: params
    })
  },    
  // 类型删除
  deviceUpholdCategoryDelete(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold-category/del',
      type: 'post',
      params: params
    })
  }, 
  // 维护记录
  deviceUpholdRecordList(data) {
    const params = data
    return request({
      url: urlParams + '/device-uphold-record/list',
      type: 'get',
      params: params
    })
  },        
}